import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import api from "../../api";
import IranFlag from "../../assets/images/iran.webp";
import {e2p} from "../../utils/utils";
import moment from "moment-jalaali";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation} from "swiper/modules";

function Customer() {
    const [loading, setLoading] = useState(true);
    const [pdrInfo, setPdrInfo] = useState(null);
    const [report, setReport] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);

    const {requestUuid} = useParams();

    const processReport = (reportData) => {
        reportData['createdAt'] = moment(reportData.created_at)
            .locale('fa')
            .format('jYYYY/jMM/jDD HH:mm');
        let SmoothingCost = 0;
        let SmoothingDuration = 0;
        let PaintingCost = 0;
        let PaintingDuration = 0;

        if (reportData.repair_items.length > 0)
            reportData.repair_items.map((repairItem) => {
                if (repairItem.type === '1') {
                    SmoothingCost += repairItem.full_price;
                    SmoothingDuration += repairItem.duration;
                } else {
                    PaintingCost += repairItem.full_price;
                    PaintingDuration += repairItem.duration;
                }
            });
        reportData['SmoothingCost'] = SmoothingCost;
        reportData['SmoothingDuration'] = SmoothingDuration;
        reportData['PaintingCost'] = PaintingCost;
        reportData['PaintingDuration'] = PaintingDuration;
        let ExtraToolsCost = 0;
        if (reportData.extra_tools.length > 0)
            reportData.extra_tools.map((extraTool) => {
                ExtraToolsCost += extraTool.price;
            });
        let PaymentsPrices = 0
        if (reportData.payments.length > 0)
            reportData.payments.map((payment) => {
                PaymentsPrices += payment.amount;
            });
        reportData['ExtraToolsCost'] = ExtraToolsCost;
        reportData['PaymentsPrices'] = PaymentsPrices;
        const fullCost = reportData.ExtraToolsCost + reportData.PaintingCost + reportData.SmoothingCost
        const discountedCost = fullCost - reportData.discount
        reportData['remainedCost'] = discountedCost - reportData.PaymentsPrices
        reportData['carOwner'] = reportData.car.car_owner
        let smoother = ''
        let painter = ''
        reportData.worker_repair_request.map(worker => {
            if (worker.type === "1") {
                smoother = worker.worker.name
            } else {
                painter = worker.worker.name
            }
        })
        reportData['Smoother'] = smoother
        reportData['Painter'] = painter


        const beforeImages = [];
        const afterImages = [];
        reportData.albums.map((album) => {
            if (album.type === 1) {
                beforeImages.push(album)
            } else {
                afterImages.push(album)
            }
        });
        reportData['beforeImages'] = beforeImages;
        reportData['afterImages'] = afterImages;

        return reportData;
    }

    const openModal = (imageUrl) => {
        setSelectedImage(imageUrl);
    };

    const closeModal = () => {
        setSelectedImage(null);
    };

    useEffect(() => {
        const fetchReports = async () => {
            const reportsData = [];
            api.get(`/repair-request/customer/${requestUuid}`)
                .then(response => {
                    const data = response.data;
                    const pdrData = data.pdrInfo;
                    const processedReport = processReport(data.data);
                    setPdrInfo(pdrData);
                    console.log(pdrData);
                    setReport(processedReport);
                    setLoading(false);
                })
                .catch(err => {
                    console.error(err);
                    setLoading(false);
                });
        };
        fetchReports();
    }, [requestUuid]);

    if (loading) {
        return <div>در حال بارگذاری...</div>;
    }

    if (!report) {
        return <div>اطلاعاتی برای نمایش موجود نیست</div>;
    }

    const statusComponent = () => {
        if (report?.status === 1) {
            return (
                <div className="my-auto"
                     style={{
                         backgroundColor: '#5bc0de',
                         color: 'white',
                         padding: '0.5rem 1rem',
                         borderRadius: '0.5rem'
                     }}
                >
                    <p className="text-black m-0 fw-bold">پذیرفته شده</p>
                </div>
            )
        } else if (report?.status === 2) {
            return (
                <div className="my-auto"
                     style={{
                         backgroundColor: '#f0ad4e',
                         color: 'white',
                         padding: '0.5rem 1rem',
                         borderRadius: '0.5rem'
                     }}
                >
                    <p className="text-black m-0 fw-bold">نوبت‌دهی شده</p>
                </div>
            )
        } else if (report?.status === 4) {
            return (
                <div className="my-auto"
                     style={{
                         backgroundColor: '#5cb85c',
                         color: 'white',
                         padding: '0.5rem 1rem',
                         borderRadius: '0.5rem'
                     }}
                >
                    <p className="text-black m-0 fw-bold">ترخیص شده</p>
                </div>
            )
        } else if (report?.status === 3) {
            return (
                <div className="my-auto"
                     style={{
                         backgroundColor: '#d9534f',
                         color: 'white',
                         padding: '0.5rem 1rem',
                         borderRadius: '0.5rem'
                     }}
                >
                    <p className="text-black m-0 fw-bold">لغو شده</p>
                </div>
            )
        } else if (report?.status === 5) {
            return (
                <div className="my-auto"
                     style={{
                         backgroundColor: '#5cb85c',
                         color: 'white',
                         padding: '0.5rem 1rem',
                         borderRadius: '0.5rem'
                     }}
                >
                    <p className="text-black m-0 fw-bold">در قسمت نقاشی</p>
                </div>
            )
        }
    }

    return (
        <div className="card-body">
            <div className="row g-1">
                <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="card p-2 h-auto mb-1 shadow-lg">
                        <div className="row pelak g-0 mb-2">
                            <div className="col">
                                <div className="row g-0">
                                    <div className="col border-start">
                                        <p className="text-center m-0 fw-bold iranNo">ایران</p>
                                        <div>
                                            <p className="border-0 text-center">{report?.car?.plate.slice(7, 9)}</p>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="border-0 text-center mt-3">{report?.car?.plate.slice(3, 6)}</p>
                                    </div>
                                    <div className="col">
                                        <p className="border-0 text-center mt-3">{report?.car?.plate.slice(2, 3)}</p>
                                    </div>
                                    <div className="col">
                                        <p className="border-0 text-center mt-3">{report?.car?.plate.slice(0, 2)}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-auto leftSide">
                                <div className="flag">
                                    <img src={IranFlag} alt="iran's flag"/>
                                </div>
                                <div className="iranText text-center">
                                    <p>I.R.</p>
                                    <p>IRAN</p>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div>
                                <div className="car-name mb-2 fw-bold text-black">
                                    {report?.car.model_name} <small
                                    className="">[{report?.car.color}]</small>
                                </div>
                                <div className="date-p mb-2 fw-bold text-black">
                                    {e2p(report?.createdAt.toString()).replace(' ', ' - ')}
                                </div>
                            </div>
                            <div>
                                {statusComponent()}
                            </div>
                        </div>

                    </div>
                    <div className="card h-auto my-1 shadow-lg">
                        <div className="card-header">
                            <div className="d-flex justify-content-between">
                                <div className="fw-bold text-black fs-4">اطلاعات صافکاری</div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col">
                                    <div className="d-flex justify-content-between my-2">
                                        <div className="fw-bold">نام صافکاری</div>
                                        <div>{pdrInfo.company}</div>
                                    </div>
                                    <div className="d-flex justify-content-between my-2">
                                        <div className="fw-bold">نام مالک</div>
                                        <div>{pdrInfo.name}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="d-flex justify-content-between my-2">
                                        <div className="fw-bold">شماره تلفن</div>
                                        <a href={`tel:${pdrInfo.mobile_number}`}>
                                            {e2p(pdrInfo.mobile_number)}
                                        </a>
                                    </div>
                                    <div className="d-flex justify-content-between my-2">
                                        <div className="fw-bold text-wrap">آدرس</div>
                                        <div>{pdrInfo.address}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-8 col-md-6 col-sm-12">
                    <div className="card shadow-lg p-2 h-100 justify-content-between p-3">
                        <table className="table table-border-bottom-0">
                            <tbody>
                            <tr>
                                <td>
                                    <small className="text-warning">شماره پذیرش:</small>
                                </td>
                                <td>
                                    {e2p((report?.tracking_code ?? report?.id).toString())}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <small
                                        className="text-warning">تلفن:</small>
                                </td>
                                <td>
                                    {e2p(report?.carOwner.mobile_number)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <small
                                        className="text-warning">مالک:</small>
                                </td>
                                <td>
                                    {report?.carOwner.name} {report?.carOwner.lastname}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <small
                                        className="text-warning">کیلومتر:</small>
                                </td>
                                <td>
                                    {e2p(report?.kilometerage.toLocaleString())}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <small className="text-warning">میزان
                                        سوخت:</small>
                                </td>
                                <td>
                                    {report?.amount_of_fuel}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <small className="text-warning">هزینه
                                        صافکاری: </small>
                                </td>
                                <td>
                                    {e2p(report?.SmoothingCost?.toLocaleString()) ?? ''} تومان
                                    ({e2p(report?.SmoothingDuration.toString())} روز)

                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <small className="text-warning">هزینه
                                        نقاشی:</small>
                                </td>
                                <td>
                                    {e2p(report?.PaintingCost?.toLocaleString()) ?? ''} تومان
                                    ({e2p(report?.PaintingDuration.toString())} روز)
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <small className="text-warning">نقاش: </small>
                                </td>
                                <td>
                                    {report?.Painter}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <small className="text-warning">صافکار:</small>
                                </td>
                                <td>
                                    {report?.Smoother}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <small className="text-warning">مبلغ
                                        لوازم:</small>
                                </td>
                                <td>
                                    {e2p(report?.ExtraToolsCost?.toLocaleString()) ?? ''} تومان
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <small className="text-warning">مبلغ
                                        پرداختی:</small>
                                </td>
                                <td>
                                    {e2p(report?.PaymentsPrices?.toLocaleString()) ?? ''} تومان
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <small
                                        className="text-warning"> تخفیف:</small>
                                </td>
                                <td>
                                    {e2p(report?.discount?.toLocaleString()) ?? ''} تومان
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <small className="text-warning">مانده
                                        حساب:</small>
                                </td>
                                <td>
                                    {e2p(report?.remainedCost?.toLocaleString()) ?? ''} تومان
                                </td>
                            </tr>
                            <tr className="border-bottom-0">
                                <td>
                                    <small className="text-warning">
                                        توضیحات:</small>
                                </td>
                                <td>
                                    {report?.description}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="card mb-3">
                    <div className="card-header">
                        <div className="d-flex justify-content-between">
                            <div className="fw-bold text-black fs-4">تصاویر</div>
                        </div>
                    </div>
                    {
                        report?.albums.length === 0 ? (
                            <div className="card-body">
                                <div className="alert alert-danger text-center" role="alert">
                                    هیچ تصویری برای نمایش وجود ندارد
                                </div>
                            </div>
                        ) : (
                            <div className="card-body">
                                <div className="row my-3">
                                    <p className="text-end">قبل</p>
                                    <Swiper
                                        spaceBetween={10}
                                        slidesPerView={2}
                                        freeMode={true}
                                        modules={[Navigation]}
                                        navigation
                                        style={{
                                            "--swiper-pagination-color": "#000000",
                                            "--swiper-navigation-color": "#000000",
                                            "--swiper-pagination-size": "10px",
                                            "--swiper-pagination-bullet-size": "10px",
                                            "--swiper-pagination-bullet-active-color": "#000000",
                                            "--swiper-pagination-bullet-color": "#000000",
                                            "--swiper-navigation-size": "30px",
                                        }}
                                    >
                                        {report?.beforeImages.map((photo, index) => (
                                            <SwiperSlide key={index}>
                                                <div className="w-100 text-center">
                                                    <img
                                                        src={photo?.url}
                                                        className="img-fluid rounded-4 cursor-pointer"
                                                        style={{maxHeight: "10rem", width: "10rem"}}
                                                        alt="..."
                                                        onClick={() => openModal(photo?.url)}
                                                    />
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                                <div className="row my-3">
                                    <p className="text-end">بعد</p>
                                    <Swiper
                                        spaceBetween={10}
                                        slidesPerView={2}
                                        freeMode={true}
                                        modules={[Navigation]}
                                        navigation
                                        style={{
                                            "--swiper-pagination-color": "#000000",
                                            "--swiper-navigation-color": "#000000",
                                            "--swiper-pagination-size": "10px",
                                            "--swiper-pagination-bullet-size": "10px",
                                            "--swiper-pagination-bullet-active-color": "#000000",
                                            "--swiper-pagination-bullet-color": "#000000",
                                            "--swiper-navigation-size": "30px",
                                        }}
                                    >
                                        {report?.afterImages.map((photo, index) => (
                                            <SwiperSlide key={index}>
                                                <img
                                                    src={photo?.url}
                                                    style={{width: "10rem", height: "10rem"}}
                                                    alt="..."
                                                    className="img-fluid rounded-4 cursor-pointer"
                                                    onClick={() => openModal(photo?.url)}
                                                />
                                            </SwiperSlide>

                                        ))}
                                    </Swiper>
                                </div>
                            </div>
                        )}
                </div>
            </div>
            {selectedImage && (
                <div
                    className="modal-overlay"
                    onClick={closeModal}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000,
                    }}
                >
                    <div
                        className="modal-content"
                        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking on the image
                        style={{
                            maxWidth: "90%",
                            maxHeight: "90%",
                            backgroundColor: "white",
                            padding: "1rem",
                            borderRadius: "8px",
                            boxShadow: "0px 4px 10px rgba(0,0,0,0.3)"
                        }}
                    >
                        <img
                            src={selectedImage}
                            alt="Selected"
                            style={{width: "100%", height: "auto", borderRadius: "8px"}}
                            onClick={closeModal}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default Customer;
